import { RootState, useAppSelector } from '../../store/store';
import '../../App.css';
import MainLayout from '../layout/MainLayout';
import { AppRoutes } from '../../axios/endPoints';
import { Navigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Link from '@mui/material/Link';

export function ProtectedRouting({ children, roles, checkActiveSubscription }: { children: React.ReactElement, roles?: string[], checkActiveSubscription?: boolean }) {
    const { t } = useTranslation();
    const { user, currentSubscription } = useAppSelector((state: RootState) => state.auth);
    const isSubscriptionExempt = useAppSelector((state: RootState) => state.profile.userInfo?.isSubscriptionExempt === true);
    
    if (user.email === null) 
    {
        return <Navigate to={AppRoutes.LOG_IN}/>
    }
    if(roles && !roles.includes(user.role))
    {
        return <MainLayout>
            <Card style={{ marginTop: '15px' }}>
                <CardHeader></CardHeader>
                <CardContent style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '40px' }}>
                    <Typography style={{ color: 'gray' }} variant='h5'>{t('NOT_AUTHORIZED')}</Typography>
                </CardContent>
            </Card>
        </MainLayout>
    }
    else if(checkActiveSubscription && !isSubscriptionExempt && !currentSubscription?.isActiveSubscription)
    {
        return <MainLayout>
            <Card style={{ marginTop: '15px' }}>
                <CardHeader></CardHeader>
                <CardContent style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '30px', flexDirection: 'column' }}>
                    <Typography style={{ color: 'gray', paddingBottom: '20px' }} variant='h5'>{t('SUBSCRIPTION_INACTIVE_LINE1')}</Typography>
                    <Typography style={{ color: 'gray', paddingBottom: '20px' }} variant='h5'>
                        {t('SUBSCRIPTION_INACTIVE_LINE2')}
                        <Link style={{ fontWeight: 'bold', textDecoration: 'none', color: 'var(--link-text-color)' }} href={AppRoutes.PROFILE} variant="h5">
                            {t('SIDEBAR_PROFILE_TEXT')}
                        </Link>
                    </Typography>
                </CardContent>
            </Card>
        </MainLayout>
    }

    return (
        <MainLayout>{children}</MainLayout>
    );
}